export default __webpack_public_path__ + "static/apprely-logo-b19d523557daa30a68eb4bae0bc5a9b6.svg";